var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1133 8.75342C12.0266 9.37342 12.6666 10.2134 12.6666 11.3334V13.3334H14.6666C15.0333 13.3334 15.3333 13.0334 15.3333 12.6668V11.3334C15.3333 9.88008 12.9533 9.02008 11.1133 8.75342Z",
    fill: "#FFF7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 8.00008C7.47243 8.00008 8.66634 6.80617 8.66634 5.33341C8.66634 3.86066 7.47243 2.66675 5.99967 2.66675C4.52692 2.66675 3.33301 3.86066 3.33301 5.33341C3.33301 6.80617 4.52692 8.00008 5.99967 8.00008Z",
    fill: "#FFF7EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99995 8.00008C11.4733 8.00008 12.6666 6.80675 12.6666 5.33341C12.6666 3.86008 11.4733 2.66675 9.99995 2.66675C9.68661 2.66675 9.39328 2.73341 9.11328 2.82675C9.66661 3.51341 9.99995 4.38675 9.99995 5.33341C9.99995 6.28008 9.66661 7.15342 9.11328 7.84008C9.39328 7.93341 9.68661 8.00008 9.99995 8.00008Z",
    fill: "#FFF7EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00033 8.66675C4.22033 8.66675 0.666992 9.56008 0.666992 11.3334V12.6667C0.666992 13.0334 0.966992 13.3334 1.33366 13.3334H10.667C11.0337 13.3334 11.3337 13.0334 11.3337 12.6667V11.3334C11.3337 9.56008 7.78033 8.66675 6.00033 8.66675Z",
    fill: "#FFF7EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleAlt);
export default __webpack_public_path__ + "static/media/people-alt.bd0fc84c94db0d904a5a7535c0c89798.svg";
export { ForwardRef as ReactComponent };